/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { Form, Input, Select } from 'antd';
// import _ from 'lodash-es';
import { ThemeContext } from 'styled-components';
// 引入ButtonStyled 组件
import { SelectMLStyled } from './SelectMLStyled';
import { BrandContext } from '@/contexts/ContextProviders';
import classnames from 'classnames';
import './index.less';

// import commStyles from '@/comm.less?modules';
const { Option } = Select;

/**
 * select
 * @param {*} param
 */
const SelectML = ({
  labelVal,
  placeVal = '请选择',
  icon,
  height,
  labelwidth,
  inputWidth,
  maxWidth,
  name,
  require = false,
  option = [],
  className = [],
  disabled = false,
  allowClear = false,
  value,
  onChange,
  onSelect,
  onClick,
}) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  return (
    <SelectMLStyled
      theme={themeContext}
      brand={brandContext}
      inputWidth={inputWidth}
      height={height}
      labelwidth={labelwidth}
    >
      <Form.Item
        colon={false}
        name={name}
        rules={require}
        className={classnames(...className)}
        label={
          <>
            {icon ? icon : ''}
            {labelVal}
          </>
        }
      >
        <Select
          style={{ minWidth: inputWidth, height: height, maxWidth: maxWidth }}
          placeholder={placeVal}
          disabled={disabled}
          allowClear={allowClear}
          defaultValue={value}
          onSelect={onSelect}
          onChange={onChange}
          value={value}
          onClick={onClick}
        >
          {option.map((item, index) => (
            <Option key={index} value={item.value} disabled={item.disabled}>
              {item.name}
            </Option>
            // <Option key={index} value={item.name}>
            //   {item.value}
            // </Option>
          ))}
        </Select>
      </Form.Item>
    </SelectMLStyled>
  );
};

export default SelectML;
